import { useMemo } from 'react';
import { useSocketEvents } from './useSocketEvents';

/**
 * Admin / operator real-time: navbat, GPS, fraud, mahalla.
 * Admin xonasiga ulanish SocketContext da avtomatik.
 */
export function useAdminSocket({
  onQueueUpdate,
  onLocationUpdate,
  onFraudWarning,
  onMahallaEntered,
} = {}) {
  const handlers = useMemo(() => {
    const h = {};
    if (onQueueUpdate) {
      h.queue_update = onQueueUpdate;
      h.order_created = onQueueUpdate;
    }
    if (onLocationUpdate) {
      h.admin_location_update = onLocationUpdate;
      h.driver_location = (data) =>
        onLocationUpdate({
          routeId: data.routeId,
          lat: data.lat,
          lng: data.lng ?? data.long,
          driverId: data.driverId,
          timestamp: data.timestamp,
        });
    }
    if (onFraudWarning) h.fraud_warning = onFraudWarning;
    if (onMahallaEntered) h.mahalla_entered = onMahallaEntered;
    return h;
  }, [onQueueUpdate, onLocationUpdate, onFraudWarning, onMahallaEntered]);

  useSocketEvents(handlers);
}
